export const GET_USERS = "GET_USERS";
export const RESET_USERS = "RESET_USERS";
export const SET_USERS_REQUEST_STATUS = "SET_USERS_REQUEST_STATUS";
